const dotenv = require('dotenv');

dotenv.config();
const { REACT_APP_VALIDATION_MODE } = process.env;

const { isEmpty, validateType } = require('../helpers/index');
const { uniqueFront } = require('./unique');
const { uniqueBack } = require('../serverSide/uniqueValidation');
const { stringSchema } = require('../schemas');

/**
 * validate fieldValue exists
 * @param {String} fieldValue
 * @param {object} validation
 * @param {*} validation.value if the field is mandatory
 * @param {string} validation.message message of error
 * @returns {(string | undefined)} `validation.message` or `undefined`
 */
const mandatory = (fieldValue, validation) => {
  const { value, message } = validation;
  return isEmpty(fieldValue) && value ? message : undefined;
};

/**
 * validate minLength of a string field
 * @param {String} fieldValue
 * @param {object} validation
 * @param {*} validation.value min length of the field
 * @param {string} validation.message message of error
 * @returns {(string | undefined)} `validation.message` or `undefined`
 */
const minLength = (fieldValue, validation) => {
  const { value, message } = validation;
  return !isEmpty(fieldValue) && fieldValue.length < value ? message : undefined;
};

/**
 * validate maxLength of a string field
 * @param {String} fieldValue
 * @param {object} validation
 * @param {*} validation.value max length of the field
 * @param {string} validation.message message of error
 * @returns {(string | undefined)} `validation.message` or `undefined`
 */
const maxLength = (fieldValue, validation) => {
  const { value, message } = validation;
  return !isEmpty(fieldValue) && fieldValue.length > value ? message : undefined;
};

/**
 * validate pattern of a string field
 * @param {String} fieldValue string field
 * @param {object} validation
 * @param {*} validation.value patter to validate
 * @param {string} validation.message message of error
 * @returns {(string | undefined)} `validation.message` or `undefined`
 */
const pattern = (fieldValue, validation) => {
  const { value, message } = validation;
  const re = new RegExp(value);
  return !isEmpty(fieldValue) && re.test(fieldValue) ? undefined : message;
};

const isValidType = (fieldValue, validation) => {
  const { value, message } = validation;
  const currentValue = fieldValue;
  return value && !isEmpty(currentValue) && !validateType(currentValue, stringSchema)
    ? message
    : undefined;
};

const unique = REACT_APP_VALIDATION_MODE !== undefined ? uniqueFront : uniqueBack;

module.exports = {
  isValidType,
  mandatory,
  maxLength,
  minLength,
  pattern,
  unique,
};
